import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { AppConfigService } from "src/app/app-config.service";
import { CommonService } from "../../common-service";
import { ListBiHealthUnitResponse } from "../../responses/business-intelligence/list-bi-health-unit.response";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../endpint-builder.service";

@Injectable({
  providedIn: 'root'
})
export class OrchestratorBusinessIntelligenceService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public getHealthUnitName(idTemplateBi: number): Observable<ListBiHealthUnitResponse> {

    let uri = `GetHealthUnitTemplate/idTemplate/${idTemplateBi}`

    return this.httpClient.get<ListBiHealthUnitResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorBusinessIntelligence) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

}
